<template>
  <b-card class="card" header-tag="header" tag="article">
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="warning"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged">
      <p>Ez most vágólapon van...</p>
    </b-alert>
    <div slot="header" class="d-flex justify-content-between align-items-center">
      <header class="header">{{ author }}</header>
      <b-button class="card-button" size="sm" @click.stop.prevent="copyMessage">Kimásolom</b-button>
    </div>
    <b-card-text>{{ body }}</b-card-text>
  </b-card>
</template>

<script>
    const clipContainer = document.querySelector('#clip-content');

    export default {
        name: 'MessageItem',
        data() {
            return {
                dismissSecs: 3,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }
        },
        props: {
            author: {
                type: String,
                default: 'Titokbuzi',
            },
            body: String,
        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            },
            copyMessage() {
                let selection = this.$el.querySelector('.card-text');
                clipContainer.value = selection.textContent;
                clipContainer.select();

                try {
                    document.execCommand('copy');
                } catch (err) {
                    alert('Hoppá! Ez nem fog menni! Bocsesz!');
                }
                this.showAlert()
                // eslint-disable-next-line
                // console.log('copy');
            }
        }
    }
</script>

<style scoped>
  .header {
    font-style: italic;
    font-weight: bold;
    color: #9e9e9e;
  }

  .container .card-header {
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-right: .5rem;
  }

</style>
